<div class="white_round padding16">
    <app-text-edit [value]="systemName" (valueChanged)='systemName = $event' (enterClicked)='nextClick()' [doFocus]="true">{{trans('systems.labels.nameSystem')}}</app-text-edit>
    <div class="details-background">
        <div id='details-background-text'>{{trans('systems.labels.background')}}</div>
        <div id='details-background-icon' #backgroundButton (click)='backgroundClick()'></div>
    </div>
    <div class="separator16"></div>
    <app-time-zone-select [initialValue]='ns.getUserTimeZone()' (valueChanged)='ns.setSystemTimeZone($event)'></app-time-zone-select>
</div>
